import React, { FC, useMemo } from 'react';
import { Col, Modal, Row, Select, Spin } from 'antd';
import { AntForm } from '@shared/styled/ant-form';
import { Formik, FormikProps } from 'formik';
import { useNavigate } from 'react-router-dom';
import { TextField, SelectField } from '@shared/modules/form';
import { useCashRegisterOperationForm, CashRegisterOperationFormValues, useCashRegisterOperationsWithSub } from '../hooks';

const CreateCashRegisterOperationForm: FC<FormikProps<CashRegisterOperationFormValues> & { id?: string }> = ({ handleSubmit, isSubmitting, id }) => {
  const navigate = useNavigate();

  const { data: parentOps = [] } = useCashRegisterOperationsWithSub();

  const operationOptions = useMemo(
    () =>
      parentOps.map((op) => (
        <Select.Option key={op.id} disabled={op.id.toString() === id} value={op.id.toString()}>
          {op.name}
        </Select.Option>
      )),
    [parentOps, id],
  );

  return (
    <Modal
      open={true}
      onOk={() => handleSubmit()}
      onCancel={() => navigate('/cash-flow/operations')}
      confirmLoading={isSubmitting}
      title={!id ? 'Kassa əməliyyatı əlavə et' : 'Kassa əməliyyatında düzəliş et'}
    >
      <AntForm layout="vertical" component="div" size="large">
        <Row gutter={[24, 0]}>
          <Col xs={24}>
            <TextField name="name" item={{ label: 'Ad' }} input={{ placeholder: 'Əməliyyatın adını daxil edin...' }} />
          </Col>
          <Col xs={24}>
            <SelectField name="parentId" item={{ label: 'Valideyn' }} input={{ placeholder: 'Valideyn əməliyyatı seçin...' }}>
              {operationOptions}
            </SelectField>
          </Col>
        </Row>
      </AntForm>
    </Modal>
  );
};

export const CreateCashRegisterOperation: FC = () => {
  const { initialValues, onSubmit, id, isLoading } = useCashRegisterOperationForm();

  if (isLoading) {
    return (
      <Modal open={true} footer={null} closable={false}>
        <Spin style={{ display: 'block', padding: '40px 0', textAlign: 'center' }} />
      </Modal>
    );
  }

  return (
    <Formik initialValues={initialValues} onSubmit={onSubmit} enableReinitialize={true}>
      {(f) => <CreateCashRegisterOperationForm {...f} id={id} />}
    </Formik>
  );
};
